import { useId, type ElementType, type PropsWithChildren } from "react";

import { motion } from "motion/react";

import type { PolymorphicProps } from "shared/types";

import { cn } from "shared/utils/cn";

import { TabsContext } from "./context";
import { tabsVariants, type TabsVariantsProps } from "./styles";

export const Tabs = <E extends ElementType = "ul">(
  props: PropsWithChildren<PolymorphicProps<E, { className?: string }>> &
    TabsVariantsProps
) => {
  const {
    as: Comp = motion.ul,
    children,
    variant = "buttons",
    className,
    ...restProps
  } = props;
  const lineLayoutId = useId();

  return (
    <Comp
      layout
      layoutRoot
      {...restProps}
      className={cn(tabsVariants({ className, variant }))}
    >
      <TabsContext.Provider value={{ variant, lineLayoutId: lineLayoutId }}>
        {children}
      </TabsContext.Provider>
    </Comp>
  );
};
